import { render, staticRenderFns } from "./DownloadSalesMarginReportPopUp.vue?vue&type=template&id=fa57a8e2&scoped=true&"
import script from "./DownloadSalesMarginReportPopUp.vue?vue&type=script&lang=js&"
export * from "./DownloadSalesMarginReportPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa57a8e2",
  null
  
)

export default component.exports